import { type Vendor } from '../../webrtc/media';
import { CustomError } from '@doxyme/api-services';
import { type ConnectionTestAbstractVendor } from './connectionTestVendor/connectionTestAbstractVendor';

export const getConnectionTestVendor = async (
  vendor: Vendor,
): Promise<ConnectionTestAbstractVendor> => {
  switch (vendor) {
    default: {
      throw new CustomError('Vendor is not supported');
    }
  }
};
